// extracted by mini-css-extract-plugin
export default {"QuestionFooter":"QuestionFooter-module-a7ae080eea335879c7ea"};